import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGoogleLogin } from "@react-oauth/google";
import UserStore from "../../stores/UserStore";
import Google from "../../icons/Google";
import Styles from "../SignupOptions/styles.module.css";
import { hRatio, triggerEvent } from "../../constants/utils";
import { handleLogin, upgradeUser } from "./utils";
import { Spinner } from "./Spinner";
import axios from "axios";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { p } from "framer-motion/client";

export default function ICLogin() {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState("");
  const [showPassword, setShowPassword] = useState(true);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.id]: e.target.value,
    }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    }
    if (!formData.password.trim()) {
      newErrors.password = "Password is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length == 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      console.log("Form submitted, ", formData);
    }
    setLoading(true);
    setApiError("");

    const email = formData.email;
    const password = formData.password;

    const loginResult = await handleLogin(email, password);

    if (!loginResult.success) {
      setApiError("Login failed");
      setLoading(false);
      return;
    }

    const upgradeResult = await upgradeUser(email);
    setLoading(false);

    navigate("/interactive/dashboard");
  };

  const SignupOptionBtn = ({ text, icon, onClick, style }) => {
    const [isPressed, setIsPressed] = useState(false);

    return (
      <div className={Styles.SignupOptionBtnContainer} style={style}>
        <div
          className={Styles.SignupOptionBtn}
          style={{ opacity: isPressed ? 0.5 : 1 }}
          onClick={onClick}
          onMouseDown={() => setIsPressed(true)}
          onMouseUp={() => setIsPressed(false)}
        >
          <div className={Styles.SignupBtnIcon}>{icon}</div>
          <p className={Styles.SignupBtnTxt}>{text}</p>
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FBD446] px-4">
      {loading ? (
        <Spinner />
      ) : (
        <div className="max-w-md w-full bg-[#FFECAE] p-8 rounded-2xl shadow-md">
          {/* logo */}
          <div className="mb-6">
            <img
              src={require("../../assets/new_onboarding/Evolve_dark.webp")}
              alt=""
              className="mx-auto h-8 object-contain"
            />
          </div>

          {/* form */}
          <form className="space-y-6" onSubmit={handleSubmit}>
            {/* email */}
            <div className="mb-4">
              <label
                htmlFor="email"
                className="block text-left text-sm font-medium text-gray-700"
              >
                Email*
              </label>
              <input
                type="email"
                id="email"
                value={formData.email}
                onChange={handleChange}
                className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="you@example.com"
              />
            </div>

            
            {/* password */}
            <div>
              <label
                htmlFor="password"
                className="block text-left text-sm font-medium text-gray-600"
              >
                Password*
              </label>
              <div className="relative">
                <input
                  type={!showPassword ? "text" : "password"} // 👈 toggle type
                  id="password"
                  value={formData.password}
                  onChange={handleChange}
                  className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 pr-10" // 👈 add right padding
                  placeholder="••••••••"
                  required
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-3 flex items-center text-gray-500"
                  onClick={() => setShowPassword((prev) => !prev)} // 👈 toggle state
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>

            {apiError ? <p className="text-red-600">Please recheck your email and password and try again</p> : ""}

            {/* submit */}
            <div>
              <button
                type="submit"
                className="w-full bg-blue-900 text-white py-2 rounded-xl"
              >
                Log in
              </button>
              <p>or</p>
              <a href="/interactive/signup" className="text-blue-600 underline hover:text-blue-800 transition-colors">Create a new account</a>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
